import { render, staticRenderFns } from "./quiz-intro-component.vue?vue&type=template&id=27e79bf0&scoped=true&"
import script from "./quiz-intro-component.vue?vue&type=script&lang=ts&"
export * from "./quiz-intro-component.vue?vue&type=script&lang=ts&"
import style0 from "./quiz-intro-component.vue?vue&type=style&index=0&id=27e79bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e79bf0",
  null
  
)

export default component.exports